module.exports = __webpack_public_path__ + "img/bart-van-der-voort.d8638cb6.jpg";